// <s-reveal> — one-shot scroll reveal. Marks itself pending, then "in" once a third of it is on screen.
// The CSS in config/styles.css owns what animates; this only flips the state. Never runs for reduced motion,
// so without JS or with reduced motion the content simply shows.
class SReveal extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!("IntersectionObserver" in window)) return;
    if (this.dataset.revealState === "in") return;

    this.dataset.revealState = "pending";
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        requestAnimationFrame(() => { this.dataset.revealState = "in"; });
        this.#observer?.disconnect();
      },
      { threshold: 0.3 },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get("s-reveal")) {
  customElements.define("s-reveal", SReveal);
}
